module.exports = __webpack_public_path__ + "img/advantage-logo.0c6ec57e.svg";